import {css, html, LitElement} from 'lit';
import {customElement, property, state} from 'lit/decorators';
import {containerStyles, normalizeStyles} from '@webs/components-library/theming';

@customElement('webs-filters-dropdown')
export class FiltersDropdown extends LitElement {

  private internalLimit: number;
  private internalOffset: number;

  static styles = [
    normalizeStyles,
    containerStyles,
    css`
    `
  ];

  private smallDevice: MediaQueryList = window.matchMedia('(min-width: 768px)');

  @state()
  private isDesktop: boolean;

  @property({attribute: 'url'})
  rootUrl: string;

  @property()
  set limit(value: number) {
    const oldValue = this.internalLimit;
    this.internalLimit = value;
    this.requestUpdate('limit', oldValue);
  }

  get limit(): number {
    return this.internalLimit;
  }

  @property({attribute: 'start-at'})
  set offset(value: number) {
    const oldValue = this.internalOffset;
    this.internalOffset = value;
    this.requestUpdate('offset', oldValue);
  }
  get offset(): number {
    return this.internalOffset;
  }

  protected render(): unknown {
    this.handleDeviceChange(this.smallDevice);

    return this.isDesktop ? html`
      <webs-filters-dropdown-desktop limit="${this.limit}" offset="${this.offset}" url="${this.rootUrl}"
                                     @resourceschange="${this.onResourcesChange}"
                                     @filteradd="${this.onFilterAdd}">
        <slot></slot>
      </webs-filters-dropdown-desktop>
    ` : html`
      <webs-filters-dropdown-mobile limit="${this.limit}" offset="${this.offset}" url="${this.rootUrl}"
                                    @resourceschange="${this.onResourcesChange}"
                                    @filteradd="${this.onFilterAdd}">
        <slot></slot>
      </webs-filters-dropdown-mobile>
    `;
  }

  private onFilterAdd(e): void {
    this.internalOffset = 0;
  }

  private onResourcesChange(e): void {
    this.dispatchEvent(new CustomEvent('resourceschange', {detail: e.detail}));
  }

  private handleDeviceChange(event): void {
    this.isDesktop = event.matches;
    this.requestUpdate();
  }
}
